import { useParams } from "react-router";
import { GridRowSelectionModel } from "@mui/x-data-grid";

import { Button } from "../../../common/Atoms/Button";
import { useAdhocActionModal } from "../../hooks/useAdhocActionModal";
import { useActionInvoicesMutation } from "../../services/api/invoiceApi/invoice";

import { ApplyInvoiceTags } from "./ApplyInvoiceTags";

interface InvoiceBulkActionsToolbarProps {
  rowSelectionModel: GridRowSelectionModel;
}

export function InvoiceBulkActionsToolbar({
  rowSelectionModel,
}: InvoiceBulkActionsToolbarProps) {
  const { organisationId } = useParams();
  const { openBulkReminders, openBulkLateFees } = useAdhocActionModal();
  const [actionInvoices, { isLoading: actionInvoiceLoading }] = useActionInvoicesMutation();

  const selectedCount = rowSelectionModel.ids.size;
  const disabled = !selectedCount || actionInvoiceLoading;

  function onUnfreezeSelected() {
    actionInvoices({
      action: `reset`,
      organisationId,
      invoiceIds: [...rowSelectionModel.ids],
    });
  }

  function onFreezeSelected() {
    actionInvoices({
      action: `freeze`,
      organisationId,
      invoiceIds: [...rowSelectionModel.ids],
    });
  }

  function onSendReminder() {
    openBulkReminders([...rowSelectionModel.ids as Set<string>]);
  }

  function onApplyLateFee() {
    openBulkLateFees([...rowSelectionModel.ids as Set<string>]);
  }

  return (
    <div className={ `flex flex-wrap items-center gap-2` }>
      { selectedCount > 0 && (
        <span className={ `whitespace-nowrap text-[13px] font-semibold text-paidniceGreen-600` }>
          { `${selectedCount} selected` }
        </span>
      ) }

      <Button
        onClick={ onFreezeSelected }
        disabled={ disabled }
        loading={ actionInvoiceLoading }
        loadingText={ `Updating...` }
        color={ `white` }
        size={ `md` }
      >
        { `Freeze` }
      </Button>

      <Button
        onClick={ onUnfreezeSelected }
        disabled={ disabled }
        loading={ actionInvoiceLoading }
        loadingText={ `Updating...` }
        color={ `white` }
        size={ `md` }
      >
        { `Unfreeze` }
      </Button>

      <Button
        onClick={ onSendReminder }
        disabled={ !selectedCount }
        color={ `white` }
        size={ `md` }
      >
        { `Send reminders` }
      </Button>

      <ApplyInvoiceTags
        selectedInvoices={ [...rowSelectionModel.ids] as string[] }
      />

      <Button
        onClick={ onApplyLateFee }
        disabled={ !selectedCount }
        color={ `paidniceGreen` }
        size={ `md` }
      >
        { `Apply late fees` }
      </Button>
    </div>
  );
}
